import { render, staticRenderFns } from "./EventListPage.vue?vue&type=template&id=1f9fe0d6&scoped=true"
import script from "./EventListPage.vue?vue&type=script&lang=js"
export * from "./EventListPage.vue?vue&type=script&lang=js"
import style0 from "./EventListPage.vue?vue&type=style&index=0&id=1f9fe0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9fe0d6",
  null
  
)

export default component.exports